import React from 'react';
import { Stack } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import useAutomaticOptions from 'utils/hooks/flux/useAutomaticOptions';
import useSaveFluxAutomaticPreference from 'utils/hooks/flux/automatic/useSaveFluxAutomaticPreference';

export default function AutomaticControlPanelActions() {
  const { clearStudyOptions } = useAutomaticOptions();
  const { setShowFormModal, saveIsEnabled } = useSaveFluxAutomaticPreference();

  return (
    <Stack className="pt-5">
      <div className="mx-auto mb-2">
        <Button
          disabled={!saveIsEnabled}
          onClick={() => setShowFormModal(true)}
        >
          Salvar nova preferência
        </Button>
      </div>
      <div className="mx-auto">
        <Button
          type="tertiary"
          className="automatic-page-clear-filter-button mt-1"
          onClick={clearStudyOptions}
        >
          Limpar filtros
        </Button>
      </div>
    </Stack>
  );
}
